import { FC } from 'react';
import { Link } from 'react-router-dom';
import { ENV_CONFIG } from 'config/environment';

interface FormSubmittedProps {
  onContinue: () => void;
}

export const FormSubmitted: FC<FormSubmittedProps> = ({ onContinue }) => {
  const supportEmail = ENV_CONFIG().RECIPIENTS_SUPPORT_EMAIL;

  return (
    <div className="onboarding-form">
      <div className="onboarding-form__gradient" />
      <div className="onboarding-form__body">
        <div className="onboarding-form__header form-submitted">
          <h1 className="h1-dtm">Form submitted</h1>
          <p className="body-text">Thank you! Your documents have been received.</p>
          <p className="body-text">
            You&rsquo;ll now be redirected to the final step in this onboarding process to connect
            your bank account securely via Stripe.
          </p>
          <p className="body-text">
            Our team will reach out if we have any questions about your submitted documents. If you
            have any questions in the meantime, please reach out to{' '}
            <Link to={`mailto:${supportEmail}`} target="_blank" rel="noopener noreferrer">
              {supportEmail}
            </Link>
            .
          </p>

          <hr className="form-submitted__divider" />

          <div className="form-submitted__policy">
            <p className="body-small-text">
              As a reminder, most Oath donors are giving to anywhere from six to 80 candidates at a
              time so even a thank-you email, call, or letter can result in an overwhelming volume
              of communication, so please take a moment to review our &ldquo;Do Not Contact&rdquo;
              policy:
            </p>
            <p className="body-small-text">
              <strong>Oath&rsquo;s &ldquo;Do Not Contact&rdquo; policy:</strong> Oath does not share
              donors&rsquo; contact information. We kindly ask that you do not attempt to contact
              donors who give through Oath for any reason! This includes all methods of
              communication &mdash; email, text, call, postcards, letters, etc. Donors using Oath
              are often donating to many candidates at once so even a thank-you note from each
              candidate can lead to dozens of unwanted contacts. We appreciate your cooperation in
              bringing more donors to the table this year with sustainable giving strategies.
            </p>
          </div>

          <button className="form-submitted__continue" onClick={onContinue} type="button">
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};
